import axios from '@/utils/request'
const urlPrefix = 'map'
// 新建模型数据
export function addModel (data) {
  return axios({
    url: urlPrefix + '/model',
    method: 'post',
    data: data
  })
}
// 更新模型
export function updateModel (data) {
  return axios({
    url: urlPrefix + '/model',
    method: 'put',
    data: data
  })
}
// 删除模型
export function delModel (data) {
  return axios({
    url: urlPrefix + '/model',
    method: 'delete',
    data: data
  })
}
// 获取单个模型详细信息
export function getModel (params) {
  return axios({
    url: urlPrefix + '/model',
    method: 'get',
    params: params
  })
}
// 获取模型列表
export function getModelList (params) {
  return axios({
    url: urlPrefix + '/model/list',
    method: 'get',
    params: params
  })
}
// 获取模型分页
export function getModelPage (params) {
  return axios({
    url: urlPrefix + '/model/page',
    method: 'get',
    params: params
  })
}
